import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const issue = {
  fetchIssue: lazyModuleMethod(() => import('./fetchIssue'), 'default'),
  fetchIssues: lazyModuleMethod(() => import('./fetchIssues'), 'default'),
  createIssue: lazyModuleMethod(() => import('./createIssue'), 'default'),
  editIssue: lazyModuleMethod(() => import('./editIssue'), 'default'),
  deleteIssue: lazyModuleMethod(() => import('./deleteIssue'), 'default'),
}
